import { getImgUrl } from './getImgUrl'
import { init } from './init'

export const viewer = {
  getImgUrl,
  init,
}


// WEBPACK FOOTER //
// ./js/animation/viewer/index.js